
import { defineComponent } from 'vue';
import ruRu from 'ant-design-vue/lib/locale-provider/ru_RU';
// import InactivityAlert from '@/utils/InactivityAlert.vue';
import NotificationController from '@/components/notification/Controller.vue';
import SessionController from '@/components/session/Controller.vue';
import { RouterConfig } from '@/utils';

const Component = defineComponent({
    components: {
        // InactivityAlert,
        NotificationController,
        SessionController,
    },
    provide() {
        return {
            sessionIsExpired: this.sessionIsExpired,
        };
    },
    data() {
        return {
            sessionIsExpired: { value: false },
            ruRu,
        };
    },
    computed: {
        shouldRenderSessionController() {
            const excludedRoutes = new Set([
                RouterConfig.login?.name,
                RouterConfig.loginOld?.name,
                RouterConfig.loginSignIn?.name,
                RouterConfig.loginPinIn?.name,
                RouterConfig.loginPinUp?.name,
                RouterConfig.loginSignInVerifyEmail?.name,
                RouterConfig.loginSignInVerifySms?.name,
                RouterConfig.forgot?.name,
                RouterConfig.forgotVerify?.name,
                RouterConfig.forgotPasswordUp?.name,
                RouterConfig.changePassword?.name,
            ]);

            const routeName = this.$route?.name;

            if (!routeName) {
                return false;
            }

            return !excludedRoutes.has(routeName.toString());
        },
    },
});

export default Component;
